import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { featureFlagGuard } from '../core/feature-flags/feature-flag-guard';
import { Features } from '../core/feature-flags/features';
import { CanDeactivateGuard } from '../core/guards/can-deactivate.guard';
import { ManagerDashboardComponent } from './manager-dashboard/manager-dashboard.component';
import { CitywireInternalAccountsGuard } from '@tpapa/citywire-internal-accounts-angular';
import { ManagerProfileComponent } from './manager-profile/manager-profile.component';

const routes: Routes = [
  {
    path: '',
    component: ManagerDashboardComponent,
    canActivate: [CitywireInternalAccountsGuard],
  },
  {
    path: ':id',
    component: ManagerProfileComponent,
    canActivate: [CitywireInternalAccountsGuard],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ManagerContentRoutingModule {}
